








































import { Component, Vue, Prop } from 'vue-property-decorator'
import { throttle } from 'lodash-es'

@Component
export default class FabButton extends Vue {
  @Prop({ type: Boolean, default: false })
  public margin!: boolean
  @Prop({ type: Object, default: () => null })
  public to!: any | null
  @Prop({ type: Object, required: false, default: () => ({}) })
  public buttonStyle!: any
  public uniqueId: string = Date.now().toString()
  public isLoading: boolean = false
  public showFull: boolean = true

  public mounted(): void {
    if (!this.$slots.fulltext) {
      return
    }
    const main = document.getElementById('main')
    const fabElm = document.getElementById(`fab-${this.uniqueId}`)
    if (main && fabElm) {
      document.addEventListener(
        'scroll',
        throttle((evt) => {
          this.showFull = main.getBoundingClientRect().top > 0
          if (this.showFull) {
            fabElm.classList.remove('small')
          } else {
            fabElm.classList.add('small')
          }
        }, 150)
      )
    }
  }

  public loading(): void {
    this.isLoading = true
  }
  public valid(): void {
    this.isLoading = true
    this.$emit('valid', () => {
      this.isLoading = false
    })
  }

  public get getClass(): any {
    return { 'is-loading': this.isLoading }
  }
}
